/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Product surface that collected the marketing SMS choice. */
export type AccountMarketingSmsPreferenceSource =
  /** The choice was collected on an Opendoor.com account form. */
  | 'COSMOS'
  /** The choice was collected during seller onboarding. */
  | 'RECEPTION';

/** Marketing SMS choice and consent attribution for the signed-in customer. */
export type AccountMarketingSmsPreferenceUpdateInput = {
  /** Stable key for the marketing SMS consent copy shown, up to 100 characters. */
  consentLanguageVersion: Types.Scalars['NonEmptyString']['input'];
  /** Email expected on the signed-in account. A mismatch rejects the update. */
  expectedEmail: Types.Scalars['EmailAddress']['input'];
  /** True when the customer declined marketing text messages. */
  marketingSmsOptedOut: Types.Scalars['Boolean']['input'];
  /** Product surface that collected the choice. */
  source: AccountMarketingSmsPreferenceSource;
};

export type AccountMarketingSmsPreferenceUpdateMutationVariables = Exact<{
  input: Types.AccountMarketingSmsPreferenceUpdateInput;
}>;


export type AccountMarketingSmsPreferenceUpdateMutation = { accountMarketingSmsPreferenceUpdate:
    | { __typename: 'CommunicationPreferences' }
    | { __typename: 'InvalidInputError' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthorizedError' }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const AccountMarketingSmsPreferenceUpdateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation AccountMarketingSmsPreferenceUpdate($input: AccountMarketingSmsPreferenceUpdateInput!) {
  accountMarketingSmsPreferenceUpdate(input: $input) {
    __typename
  }
}
    `) as unknown as TypedDocumentString<AccountMarketingSmsPreferenceUpdateMutation, AccountMarketingSmsPreferenceUpdateMutationVariables>;